<script>
    export let body = ''
    export let type

    export let wide = false
    export let render_markdown = false

    import Highlight from 'svelte-highlight'
    import SvelteMarkdown from 'svelte-markdown'
    import sanitizeHtml from 'sanitize-html'

    // themes
    import bash from "svelte-highlight/src/languages/bash" // sh
    import cpp from "svelte-highlight/src/languages/cpp"
    import css from "svelte-highlight/src/languages/css"
    import dockerfile from "svelte-highlight/src/languages/dockerfile"
    import haskell from "svelte-highlight/src/languages/haskell"
    import javascript from "svelte-highlight/src/languages/javascript"
    import json from "svelte-highlight/src/languages/json"
    import julia from "svelte-highlight/src/languages/julia"
    import latex from "svelte-highlight/src/languages/latex" // tex
    import markdown from "svelte-highlight/src/languages/markdown"
    import plaintext from "svelte-highlight/src/languages/plaintext" // plain_text
    import python from "svelte-highlight/src/languages/python"
    import sql from "svelte-highlight/src/languages/sql"
    import xml from "svelte-highlight/src/languages/xml"

    const map_type = t => {
        const mapping = {
            'c_cpp': cpp,
            'css': css,
            'dockerfile': dockerfile,
            'haskell': haskell,
            'html': xml,
            'javascript': javascript,
            'json': json,
            'julia': julia,
            'markdown': markdown,
            'plain_text': plaintext,
            'python': python,
            'sql': sql,
            'sh': bash,
            'tex': latex
        }

        return mapping[t] ?? plaintext
    }

    import tomorrowNight from 'svelte-highlight/src/styles/tomorrow-night'
    import HumanFileSize from './HumanFileSize.svelte'


</script>

<svelte:head>
  {@html tomorrowNight}

<style>
    .pre-sandbox {
        padding: 0;

    }

    .pre-sandbox > code {
        padding: 1em 0 !important;
        white-space: pre-wrap;
    }
</style>
</svelte:head>

<style>
.code_container {
    margin: 1em 0;


    padding: 0;
}

@media (min-width: 768px) {
    .code_container {
        padding: 0 10vw;
    }
}

.code_display {
    padding-bottom: 1em;

    background-color: #2d2d2d;
    margin: 1em 0 0 0;
}

.code_metadata {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    padding-bottom: 0;
    margin: 0.5em 0 2em 0;
}


.code_view_button {
    cursor: pointer;
    user-select: none;
}

.content {
    margin-top: 1em;
}
</style>

<div class="code_display { wide ? 'code_container' : 'page_container'}">
    {#if type !== 'markdown' || !render_markdown}
        <Highlight 
            class="pre-sandbox" 
            language={map_type(type)} 
            code={body || ''} />
    {:else}
        <div class="content">
            <SvelteMarkdown
                    source={body || ''}
                    options={ {
                        sanitize: true,
                        sanitizer: sanitizeHtml
                    }}
                    />
        </div>
    {/if}
</div>
<div class="code_metadata page_container">
    {#if type !== 'markdown'}
        <span>{type} (<HumanFileSize bytes={body.length}/>)</span>
    {:else}
        <span>
            <span>markdown</span>
            <span
                class="code_view_button has-text-link"
                on:click={() => render_markdown = !render_markdown}>
                {#if render_markdown}
                    (rendered)
                {:else}
                    (source)
                {/if}
            </span>
            <span>(<HumanFileSize bytes={body.length}/>)</span>
        </span>
    {/if}
    <span 
        class="code_view_button has-text-link"
        on:click={() => wide = !wide}>
        {#if wide}
            <span>normal view</span>
        {:else}
            <span>wide view</span>
        {/if}
    </span>
</div>
